import React from "react";
import { Icon } from "@iconify/react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/common/PageHeader";
import BanksLayer from "../../components/banks/BanksLayer";

const BanksPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Meus bancos" />

        {/* Header Section */}
        <PageHeader
          icon="mdi:bank"
          title="Contas Bancárias"
          subtitle="Gerencie suas contas bancárias para receber pagamentos e comissões"
        />

        {/* InvoiceListLayer */}
        <BanksLayer />

      </MasterLayout>

    </>
  );
};

export default BanksPage;
